import { IDriverMessagesService } from '@/features/messages/IDriverMessagesService';
import { inject, injectable } from 'inversify';
import { IDriverMessagesApi, IDriverMessagesApiId } from '@/features/messages/IDriverMessagesApi';
import { MessageTemplate } from '@/features/messages/MessageTemplate';
import { DriverMessage } from '@/features/messages/DriverMessage';
import { TransportType } from '@/features/shared/models/TransportType';

@injectable()
export default class DriverMessagesService implements IDriverMessagesService {
    @inject(IDriverMessagesApiId)
    api!: IDriverMessagesApi;

    async getTemplates(transportType: TransportType): Promise<MessageTemplate[]> {
        try {
            return await this.api.getTemplates(transportType);
        } catch {
            return new Array<MessageTemplate>();
        }
    }

    async sendMessage(message: DriverMessage): Promise<void> {
        try {
            await this.api.sendMessage(message);
        } catch {
            /* empty */
        }
    }
}
